import { useLocation } from 'react-router';
import { usePausePoint } from '../../queries/BorrowerFields/ApplicationFields';

export const usePausePointTracker = () => {
    const location = useLocation();
    const [, set_pausePoint] = usePausePoint();

    const updatePausePoint = () => {
        const urlPagePart = location.pathname.split('/').slice(1).join('/') + location.search;
        set_pausePoint(urlPagePart);
    };

    const clearPausePoint = () => {
        set_pausePoint(null);
    };

    return { updatePausePoint, clearPausePoint };
};
